module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraGrid),
      expression: "mostraGrid"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onNew
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Município")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redistributeParticipants
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distribuir Participantes Proporcionalmente")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.redistributeValues
    }
  }, [_c('i', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Distribuir Valores Proporcionalmente")]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered table-striped"
  }, [_c('thead', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_c('tr', [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("Fase")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("CEP")]), _vm._v(" "), _c('td', [_vm._v("Município")]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("Valor das ativ. por município")]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v("% das ativ. por município")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v("Número de participantes por município")]), _vm._v(" "), _c('td', [_vm._v("% participantes por municípios")]), _vm._v(" "), _c('td', [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, _vm._l((_vm.table.items), function(item, index) {
    return _c('tr', [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(item.phase))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cep))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(_vm._f("real")(item.valueByActivity)))]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('td', [_vm._v(_vm._s(_vm._f("percentage")(item.percentageByActivity)))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalParticipants))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("percentage")(item.percentage)))]), _vm._v(" "), _c('td', [_c('div', [_c('b-button', {
      class: ['btn btn-flat btn-sm', _vm.proposta.proposalPhase === 'CADASTRO' || _vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE' ? 'btn-primary' : 'btn-default'],
      attrs: {
        "type": "button",
        "disabled": _vm.proposta.proposalPhase !== 'CADASTRO' && _vm.proposta.proposalPhase !== 'ANALISE' && _vm.proposta.proposalPhase !== 'PRE_ANALISE'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.edita(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Editar")]), _vm._v(" "), _c('b-button', {
      staticClass: "btn btn-danger btn-sm btn-flat",
      attrs: {
        "type": "button",
        "disabled": false
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exclui(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Excluir")])], 1)])])
  }), 0)])]), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('table', {
    staticClass: "table b-table table-bordered b-table-stacked-md",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total Fundação: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('FUNDACAO'))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total Fundação Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('FUNDACAO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total Contrapartida: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('CONTRAPARTIDA'))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total Contrapartida Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('CONTRAPARTIDA'))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total Parceiro Estratégico: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('PARCEIRO_ESTRATEGICO'))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total Parceiro Estratégico Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('PARCEIRO_ESTRATEGICO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total do Projeto: " + _vm._s(_vm._f("real")(_vm.calculaValorAtividadeporFase('PARCEIRO_ESTRATEGICO') + _vm.calculaValorAtividadeporFase('CONTRAPARTIDA') + _vm.calculaValorAtividadeporFase('FUNDACAO'))))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total  Parceiro Estratégico Restante: " + _vm._s(_vm._f("real")(_vm.calculaValorPermitidoAtividadeporFase('PARCEIRO_ESTRATEGICO') + _vm.calculaValorPermitidoAtividadeporFase('CONTRAPARTIDA') + _vm.calculaValorPermitidoAtividadeporFase('FUNDACAO'))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-right": "none"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Total Participantes: " + _vm._s(_vm.totalParticipantes))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "border-left": "none"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total  Parceiro Estratégico Restante: " + _vm._s(_vm.totalParticipantes - _vm.totalParticipantesMunicipios))])])])]) : _vm._e()])], 1)])]), _vm._v(" "), (!_vm.mostraGrid) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-6 well"
  }, [(_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('fase')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "phase"
    }
  }, [_vm._v("Fase:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade.phase),
      expression: "cidade.phase"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "fase",
      "aria-label": "Recurso"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.cidade, "phase", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.selecionaFase]
    }
  }, [_c('option', {
    attrs: {
      "value": "FUNDACAO"
    }
  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CONTRAPARTIDA"
    }
  }, [_vm._v("Contrapartida")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PARCEIRO_ESTRATEGICO"
    }
  }, [_vm._v("P.Estratégico")])])]), _vm._v(" "), (_vm.errors.first('fase')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('fase')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    attrs: {
      "approval": "addMunCtrl.approval",
      "state": "addMunCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:8|max:8'),
      expression: "'required|min:8|max:8'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cep",
      "type": "text",
      "mask": "#####-###"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.loadCityAndState($event)
      }
    },
    model: {
      value: (_vm.cidade.cep),
      callback: function($$v) {
        _vm.$set(_vm.cidade, "cep", $$v)
      },
      expression: "cidade.cep"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3",
    staticStyle: {
      "padding": "7px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.cidade.name) + "\n        ")])]), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('valor')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "valueByActivity"
    }
  }, [_vm._v("Valor das atividades por município:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addMunCtrl.approval",
      "state": "addMunCtrl.approvalState"
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max_value:' + _vm.valorPermitidoAtividade),
      expression: "'required|max_value:' + valorPermitidoAtividade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "valor",
      "type": "text",
      "ng-change": "addMunCtrl.onChangeValueByActivity(cidade)",
      "ng-blur": "addMunCtrl.onChangeMunicipalizationValues()",
      "disabled": !_vm.cidade.phase
    },
    model: {
      value: (_vm.cidade.valueByActivity),
      callback: function($$v) {
        _vm.$set(_vm.cidade, "valueByActivity", $$v)
      },
      expression: "cidade.valueByActivity"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('valor')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('valor')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.proposta.proposalPhase === 'ANALISE' || _vm.proposta.proposalPhase === 'PENDENTE_EM_ANALISE') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('porcentagem das atividades')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "percentageByActivity"
    }
  }, [_vm._v("Porcentagem das atividades por município:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "porcentagem das atividades",
      "type": "text",
      "mask": ['###,##%', '##,##%', '#,##%']
    },
    model: {
      value: (_vm.porcentagemAtividade),
      callback: function($$v) {
        _vm.porcentagemAtividade = $$v
      },
      expression: "porcentagemAtividade"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('porcentagem das atividades')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('porcentagem das atividades')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('número de participantes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "totalParticipants"
    }
  }, [_vm._v("Número de participantes:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addMunCtrl.approval",
      "state": "addMunCtrl.approvalState"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cidade.totalParticipants),
      expression: "cidade.totalParticipants"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        numeric: true
      }),
      expression: "{required: true, numeric: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "número de participantes",
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.cidade.totalParticipants)
    },
    on: {
      "change": _vm.onChangeTotalParticipants,
      "keyup": _vm.onChangeTotalParticipants,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.cidade, "totalParticipants", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('número de participantes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('número de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('porcentagem de participantes')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "porcentagem de participantes"
    }
  }, [_vm._v("Porcentagem de participantes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    attrs: {
      "approval": "addMunCtrl.approval",
      "state": "addMunCtrl.approvalState"
    }
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "porcentagem de participantes",
      "mask": ['###,##%', '##,##%', '#,##%'],
      "type": "text"
    },
    model: {
      value: (_vm.porcentagemParticipantes),
      callback: function($$v) {
        _vm.porcentagemParticipantes = $$v
      },
      expression: "porcentagemParticipantes"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('porcentagem de participantes')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('porcentagem de participantes')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-4"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-municipalization-add"
    },
    on: {
      "click": _vm.onAdd
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button",
      "id": "proposal-municipalization-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar\n          ")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dedb889!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/municipalizacaoOld.vue
// module id = 2003
// module chunks = 1